<template>
	<div>
		<router-view v-if="$route.path.includes('quoteDatails')"></router-view>
		<div v-else>
			<div class="navlist">
				<ul>
					<li v-for="(i,Index) in navlist"
					  :key='Index'
					  :class="{'classType':Index==navindex}" 
					   @click="tobnav(Index)"
					>
					{{i.name}}
					<div v-if="Index==navindex"></div>
					</li>
				</ul>
				<div class="navso">
					<div class="soinput">
					  <i class="el-icon-search"></i>
					  <input type="text" placeholder="请输入您要搜索的内容" v-model="keyword"> 
					</div>
					<button @click="sosuo">搜索</button>
				</div>
			</div>
			<myQuoteList :list='list'></myQuoteList>
			<div class="fenye">
			   <el-pagination
				 background
				 @current-change="handleCurrentChange"
				 :current-page.sync="currentPage1"
				 :page-size="9"
				 layout="total, prev, pager, next ,jumper"
				 :total="total">
			   </el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import { QuoteIndex } from "@/api/api.js"
	import myQuoteList from '@/common/myQuoteList.vue';
	export default {
	  name: 'HelloWorld',
	  components:{
		myQuoteList  
	  },
	  data() {
	    return {
			  navindex:0,
			  navlist:[
				{name:"全部",status:""},
				{name:"已中标",status:"1"},
				{name:"未中标",status:"0"},
			  ],
			  list:[],
			  page:1,
			  select:"",
			  keyword:"",
			  total:0,
			  pagecount:"",
			  currentPage1:""
	    }
	  },
	  created() {
	  	this.getlist()
	  },
	  methods: {
		handleCurrentChange(e){
			this.page=e
			this.getlist()
		},
		tobnav(index){
			this.navindex=index
			this.page=1
			this.select=this.navlist[this.navindex].status
			console.log(this.select)
			this.getlist()
		},
		sosuo(){
			this.page=1
			this.getlist()
		},
		getlist(){
			QuoteIndex({
				is_select:this.select,
				page:this.page,
				keyword:this.keyword,
				limit:'9'
			}).then(res=>{
				this.list=res.data.data.data
				this.total= res.data.data.total
				this.pagecount=res.data.data.pass_count
				this.currentPage1=res.data.data.current_page
			})
		}
	  },
	}
</script>

<style scoped>
	.navlist{
		width:1200px;
		margin:0 auto;
		height: 48px;
		background: #FFFFFF;
		border-radius: 12px;
		margin-top:24px;
		margin-bottom:24px;
		padding:8px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.navlist ul{
		display:flex;
		align-items:center;
	}
	.navlist li{
		margin-right:16px;
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		cursor:pointer;
	}
	.navso{
		width: 360px;
		height: 32px;
		background: #FFFFFF;
		border-radius: 12px;
		border: 1px solid #1E3A8A;
		padding: 7px 8px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.soinput{
		display:flex;
		align-items:center;
	}
	.navso input{
		width:270px;
		border:none;
		outline:none;
		margin-left:5px;
	}
	.navso button{
		width: 40px;
		height: 24px;
		background: #1E3A8A;
		border-radius: 6px;
		color:#fff;
		border:none;
		outline: none;
		font-weight: 400;
		font-size: 12px;
		cursor: pointer;
	}
	.fenye{
		width:100%;
		display:flex;
		justify-content:center;
		align-items: center;
		padding-bottom:60px;
	}
	.classType{
		color:#1E3A8A  !important;
	}
</style>